import {useState} from 'react'
import {getGuestLearningData} from '~/app/utils/helpers'
const useLearningCenterGuest = () => {
    const [guestLCData, setGuestLCData] = useState(() => getGuestLearningData())
    const updateGuestLCData = (data) => {
        setGuestLCData((prevData) => {
            const newData = {...prevData, ...data}
            localStorage.setItem('guestLearningCenterData', JSON.stringify(newData))
            return newData
        })
    }

    const clearGuestLCData = () => {
        localStorage.removeItem('guestLearningCenterData')
        setGuestLCData(null)
    }

    return {guestLCData, setGuestLCData, updateGuestLCData, clearGuestLCData}
}

export default useLearningCenterGuest
